module.exports = __webpack_public_path__ + "static/media/audience3.89706de5.jpg";